import React from 'react';

import style from './sidebar.module.less';
import { SidebarHelp } from './need-help/need-help';

export const Sidebar = () => {
  return (
    <div className={style.sidebar}>
      <SidebarHelp />
    </div>
  );
};
